import { render, staticRenderFns } from "./router-board.vue?vue&type=template&id=706323fe&"
import script from "./router-board.vue?vue&type=script&lang=js&"
export * from "./router-board.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports